module.exports = require("ramda/src/merge");